// src/helpers/validationSchemas/settings/getIds.ts
var getModifierTagId = (key, field) => {
  return `modifierTags-${key}-${field}`;
};
var getAdId = (key, field) => {
  return `ads-${key}-${field}`;
};
var getSpecialTagId = (key, field) => {
  return `specialTags-${key}-${field}`;
};
var getDiscountReasonId = (key, field) => {
  return `discountReasons-${key}-${field}`;
};
var getCustomTenderId = (key, field) => {
  return `customTenders-${key}-${field}`;
};
var getCourseId = (key, field) => {
  return `courses-${key}-${field}`;
};
var getOrderSeatTagId = (key, field) => {
  return `orderSeatTags-${key}-${field}`;
};
var getOpenItemTypeId = (key, field) => {
  return `openItemTypes-${key}-${field}`;
};
var getPrinterRulesId = (key, field) => {
  return `printerRules-${key}-${field}`;
};
var getPrepStationId = (key, field) => {
  return `prepStations-${key}-${field}`;
};

export { getAdId, getCourseId, getCustomTenderId, getDiscountReasonId, getModifierTagId, getOpenItemTypeId, getOrderSeatTagId, getPrepStationId, getPrinterRulesId, getSpecialTagId };
